import ElectrumCoinSvg from './ElectrumCoinSvg';

export default ElectrumCoinSvg;

export { ElectrumCoinSvg };
